import { Subject } from 'rxjs';
import * as EventBus from 'vertx3-eventbus-client';
import fetch from 'node-fetch';

var MinecraftProvider = /** @class */ (function () {
    function MinecraftProvider(eventBusURL, code) {
        this.eventBusURL = eventBusURL;
        this.code = code;
    }
    MinecraftProvider.prototype.connect = function () {
        var _this = this;
        var fetchFunction = typeof window === 'undefined' ? fetch : window.fetch;
        return fetchFunction(this.eventBusURL + '/login/' + this.code)
            .then(function (response) { return response.text(); })
            .then(function (token) { return new Minecraft(_this.eventBusURL, token); });
    };
    return MinecraftProvider;
}());
var Minecraft = /** @class */ (function () {
    function Minecraft(eventBusURL, token) {
        var _this = this;
        this.token = token;
        this.callbacks = new Map();
        this.eb = new EventBus(eventBusURL + '/eventbus?token=' + token);
        this.eb.enableReconnect(true);
        this._onConnect = new Promise(function (resolve) {
            _this.eb.onopen = function () {
                resolve();
            };
        });
        this._onConnect.then(function () {
            _this.eb.registerHandler("mcs.events", function (error, message) {
                if (error == null) {
                    var callback = _this.callbacks.get(message.body.event);
                    if (callback) {
                        callback.next(message.body);
                    }
                }
                else {
                    console.log("Vert.x Event Bus received error:", error);
                }
            });
        });
    }
    Object.defineProperty(Minecraft.prototype, "loggedInPlayer", {
        get: function () {
            return require('jwt-decode')(this.token).playerUUID;
        },
        enumerable: true,
        configurable: true
    });
    Minecraft.prototype.showTitle = function (playerUUID, title) {
        var _this = this;
        return this._onConnect.then(function () { return new Promise(function (resolve, reject) {
            return _this.eb.send(Minecraft.address, { "playerUUID": playerUUID, "message": title }, { "action": "showTitle" }, _this.handle(resolve, reject));
        }); });
    };
    Minecraft.prototype.narrate = function (playerUUID, entity, text) {
        var _this = this;
        return this._onConnect.then(function () { return new Promise(function (resolve, reject) {
            return _this.eb.send(Minecraft.address, { "playerUUID": playerUUID, "entity": entity, "text": text }, { "action": "narrate" }, _this.handle(resolve, reject));
        }); });
    };
    Minecraft.prototype.runCommand = function (playerUUID, command) {
        var _this = this;
        return this._onConnect.then(function () { return new Promise(function (resolve, reject) {
            return _this.eb.send(Minecraft.address, { "playerUUID": playerUUID, "command": command }, { "action": "runCommand" }, _this.handle(resolve, reject));
        }); });
    };
    Minecraft.prototype.getItemHeld = function (playerUUID, hand) {
        var _this = this;
        return this._onConnect.then(function () { return new Promise(function (resolve, reject) {
            return _this.eb.send(Minecraft.address, { "playerUUID": playerUUID, "hand": hand.toString() }, { "action": "getItemHeld" }, _this.handle(resolve, reject));
        }); });
    };
    Minecraft.prototype.addRemoveItem = function (playerUUID, amount, item) {
        var _this = this;
        return this._onConnect.then(function () { return new Promise(function (resolve, reject) {
            return _this.eb.send(Minecraft.address, { "playerUUID": playerUUID, "amount": amount, "item": item }, { "action": "addRemoveItem" }, _this.handle(resolve, reject));
        }); });
    };
    // All Event Handlers go here
    Minecraft.prototype.whenCommand = function (commandName) {
        return this.whenRegister('newCmd' + commandName);
    };
    Minecraft.prototype.whenInside = function (playerUUID, name) {
        var _this = this;
        return this._onConnect.then(function () { return new Promise(function (resolve, reject) {
            return _this.eb.send(Minecraft.address, { "playerUUID": playerUUID, "name": name }, { "action": "whenInside" }, _this.handle(resolve, reject));
        })
            .then(function () { return _this.whenRegister("player_inside_" + name + playerUUID); }); });
    };
    Minecraft.prototype.whenRegister = function (eventName) {
        var _this = this;
        if (this.callbacks.get(eventName)) {
            return Promise.reject("can't re-register already registered event " + eventName);
        }
        return this._onConnect.then(function () { return new Promise(function (resolve, reject) {
            return _this.eb.send("mcs.actions", { "action": "registerCondition", "condition": eventName }, function (err) {
                if (!err) {
                    resolve(new Registration(eventName, _this.callbacks));
                }
                else {
                    reject(err);
                }
            });
        }); });
    };
    Minecraft.prototype.whenEntityRightClicked = function (entityName) {
        return this.whenRegister("entity_interaction:" + entityName + "/right clicked");
    };
    Minecraft.prototype.whenPlayerJoins = function (playerUUID) {
        return this.when(playerUUID, "playerJoined");
    };
    Minecraft.prototype.when = function (playerUUID, eventName) {
        var _this = this;
        var existingSubject = this.callbacks.get(eventName);
        if (existingSubject) {
            return existingSubject;
        }
        var subject = new Subject();
        this._onConnect.then(function () { return _this.eb.send("mcs.actions", { "action": "registerCondition", "condition": eventName, "playerUUID": playerUUID }, function (err) {
            if (!err) {
                _this.callbacks.set(eventName, subject);
            }
            else {
                subject.error(err);
            }
        }); });
        return subject;
    };
    Minecraft.prototype.handle = function (resolve, reject) {
        return function (err, result) {
            if (!err) {
                resolve(result.body);
            }
            else {
                console.log("error: ", err);
                reject(err);
            }
        };
    };
    Minecraft.address = "ch.vorburger.minecraft.storeys";
    return Minecraft;
}());
var HandType;
(function (HandType) {
    HandType["MainHand"] = "MainHand";
    HandType["OffHand"] = "OffHand";
})(HandType || (HandType = {}));
var ItemType;
(function (ItemType) {
    ItemType["Nothing"] = "Nothing";
    ItemType["Apple"] = "Apple";
    ItemType["Beef"] = "Beef";
    ItemType["Beetroot"] = "Beetroot";
    ItemType["Boat"] = "Boat";
    ItemType["Book"] = "Book";
    ItemType["Bow"] = "Bow";
    ItemType["Bowl"] = "Bowl";
    ItemType["Bread"] = "Bread";
    ItemType["Cactus"] = "Cactus";
    ItemType["Cake"] = "Cake";
    ItemType["Carrot"] = "Carrot";
    ItemType["Cauldron"] = "Cauldron";
    ItemType["Chicken"] = "Chicken";
    ItemType["Clock"] = "Clock";
    ItemType["Cookie"] = "Cookie";
})(ItemType || (ItemType = {}));
var Token = /** @class */ (function () {
    function Token() {
    }
    return Token;
}());
var Registration = /** @class */ (function () {
    function Registration(commandName, callbacks) {
        this.commandName = commandName;
        this.callbacks = callbacks;
        this.subject = new Subject();
        this.callbacks.set(this.commandName, this.subject);
    }
    Registration.prototype.on = function () {
        return this.subject;
    };
    Registration.prototype.unregister = function () {
        this.callbacks.delete(this.commandName);
        //TODO send an unregister event to the server and handle
        // this.eb.send("ch.vorburger.minecraft.storeys", {})
    };
    return Registration;
}());

export { HandType, ItemType, Minecraft, MinecraftProvider, Registration, Token };
